module.exports = __webpack_public_path__ + "static/media/h5_banner3.79bca15a.png";